import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { StudentScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface SpellingMapDetailsResponse {
  spelling_map_details: {
    created_at: number
    map_number: number
    correct_count: number
    total_count: number
    incorrect: Record<string, string>
    correct: string[]
  }[]
}

export type SpellingMapDetailsData = SpellingMapDetailsResponse['spelling_map_details']

export async function spellingMapDetails(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: StudentScope,
  period: NormalizedInterval,
): Promise<Nullable<SpellingMapDetailsData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('spelling_map_details', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<SpellingMapDetailsResponse>(url, query)
  if (!data) return null

  const { spelling_map_details } = data
  if (spelling_map_details.length === 0) return null

  return spelling_map_details
}
